import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useState } from "react";
import {
  parsePhoneNumberFromString,
  getExampleNumber,
} from "libphonenumber-js";

const InputFields = ({
  labelName,
  type,
  name,
  value,
  inputColor,
  labelProps,
  inputProps,
  handleChangeData,
  error,
  helperText,
  disabled = false,
  defaultCountry = "US",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const examplePhoneNumber =
    getExampleNumber(defaultCountry)?.formatInternational() ||
    "+1 202 555 0143";

  const yesterday = new Date();
  const formattedYesterday = yesterday.toISOString().split("T")[0];

  const handleInputChange = (e) => {
    let newValue = e.target.value;
    if (type === "phone") {
      if (newValue.length === 1 && newValue !== "+") {
        newValue = "";
      } else {
        newValue = newValue.replace(/[^\d+]/g, "");
        if (newValue.indexOf("+") > 0) {
          newValue = newValue.replace(/\+/g, "");
        }
      }

      try {
        const phoneNumber = parsePhoneNumberFromString(newValue);
        if (!phoneNumber?.isValid()) {
          setPhoneError("Invalid phone number (+1 202 555 0143)");
        } else {
          setPhoneError("");
        }
      } catch {
        setPhoneError("Invalid phone number (+1 202 555 0143)");
      }
    }

    handleChangeData({ target: { name, value: newValue } });
  };

  return (
    <TextField
      required
      id="outlined-required"
      label={labelName}
      fullWidth
      className="mb-3"
      type={
        type === "password"
          ? showPassword
            ? "text"
            : "password"
          : type === "phone"
          ? "tel"
          : type
      }
      color="secondary"
      name={name}
      onChange={handleInputChange}
      value={value}
      error={Boolean(phoneError || error)}
      helperText={phoneError || helperText}
      autoComplete="off"
      disabled={disabled}
      placeholder={type === "phone" ? examplePhoneNumber : ""}
      InputLabelProps={
        type === "date"
          ? {
              shrink: true,
              style: { color: inputColor },
            }
          : labelProps
      }
      inputProps={{
        ...(type === "date" && {
          max: new Date(new Date().setFullYear(new Date().getFullYear() - 12))
            .toISOString()
            .split("T")[0],
        }),
        ...inputProps,
      }}
      InputProps={{
        style: {
          color: inputColor,
        },
        endAdornment:
          type === "password" ? (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
        inputMode: type === "phone" ? "tel" : undefined,
      }}
      variant="outlined"
    />
  );
};

export default InputFields;
